import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDHHsqOUPNcwXZQKY750IlMt7ZbBA2Ifng",
  authDomain: "myjoke-66907.firebaseapp.com",
  projectId: "myjoke-66907",
  storageBucket: "myjoke-66907.firebasestorage.app",
  messagingSenderId: "282848695486",
  appId: "1:282848695486:web:57e802fe2b0d00a08afaef"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()

// timestamp
const timestamp = firebase.firestore.Timestamp

export { projectFirestore, projectAuth, timestamp }